<template>
  <div>虫情</div>
</template>

<script>
export default {};
</script>

<style>
</style>